<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";
import LogWriter from "@/components/LogWriter.vue";
import LogList from "@/components/LogList.vue";

const route = useRoute();
const router = useRouter();
const orderId = route.params.id as string;
const deviceId = ref(undefined as string | undefined);
const userId = ref(undefined as string | undefined);
const loaded = ref(false);

onMounted(async () => {
  const result = await RvApi.searchGenericLookup<{
    deviceId: string;
    userId: string;
  }>("order/orderId", orderId, 1, 0);
  deviceId.value = result[0].deviceId;
  userId.value = result[0].userId;
  loaded.value = true;
});
</script>

<template>
  <h2>Log</h2>
  <p v-show="deviceId">
    This log is attached to the device with id
    <a :href="`/device/${deviceId}`"> {{ deviceId }} </a>, entries will be
    tagged with the order id <a :href="`/order/${orderId}`"> {{ orderId }} </a>.
    <span v-if="userId">
      Additional log information may be available on the
      <a :href="`/user/${userId}`">user page</a>
    </span>
  </p>
  <pn-spinner size="4" v-show="!loaded" />
  <section v-if="!!loaded && deviceId">
    <LogWriter :deviceId="deviceId" :userId="userId" :orderId="orderId" />
  </section>
  <section v-if="!!loaded && deviceId">
    <LogList type="device" :searchId="deviceId" />
  </section>
  <pn-button small="true" v-on:click="router.go(-1)">Back</pn-button>
</template>
